<template>
  <form id="cardFilterForm" method="post" action="/nl/my-arriva-business/card/filter" class="filter-datatable"
        @submit.prevent="filter">
    <h3>Zoek op:</h3>
    <div class="row">
      <div class="small-12 medium-6 columns">
        <engraved-id :value="engravedId"
                     :$v="$v.engravedId"
                     :label="'OV-Chipkaartnummer'"
                     :validate-on-blur="false"
                     :show-part-validation-errors="false"
                     @input="value => setEngravedId(value)"/>
      </div>
      <div class="small-12 medium-6 columns">
        <input-field
          id="ascription"
          :$v="$v.ascription"
          :value="ascription"
          :required="false"
          :maxlength="50"
          :custom-container-classes="['gridelement', 'formsectioncompound']"
          name="ascription"
          label="Tenaamstelling"
          @input="setAscription"
        />
      </div>
    </div>
    <div class="row">
      <div class="small-12 medium-6 columns">
        <select-field
          id="cardReplacementStatus"
          :$v="$v.cardReplacementStatus"
          :value="cardReplacementStatus"
          :options="cardReplacementStatusOptions"
          :required="true"
          :custom-container-classes="['gridelement', 'formsectioncompound']"
          name="cardReplacementStatus"
          label="Status *"
          @change="setCardReplacementStatus"
        />
      </div>
      <div class="small-12 medium-6 columns">
        <div class="gridelement formsectioncompound">
          <div class="wm-field-label">&nbsp;</div>
          <div class="jq_gridcontentarea">
            <div class="wm-field small-12 columns">
              <div class="wm-field-input">
                <button id="filterSubmit" type="submit" class="confirmation">
                  Zoeken
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex'
import InputField from './fields/InputField'
import SelectField from './fields/SelectField'
import EngravedId from './fields/EngravedId'
import {SET_FILTER_PAIR} from '../../store/modules/card/mutation-types'
import { maxLength } from 'vuelidate/lib/validators'
import {buildFilterPair} from '../../types/filter-pair'
import {
  FILTER_CARD_REPLACEMENT_STATUS,
  FILTER_COMBINED_ASCRIPTIONS,
  FILTER_ENGRAVED_ID
} from '../../types/company-cards-filter'

export default {
  name: 'CardFilterForm',
  components: {
    InputField,
    SelectField,
    EngravedId
  },
  data: function () {
    return {
      cardReplacementStatusOptions: [
        { value: 'onlyActive', text: this.$t('card.replacementStatusOnlyActive') },
        { value: 'onlyReplaced', text: this.$t('card.replacementStatusOnlyReplaced') },
        { value: 'all', text: this.$t('card.replacementStatusAll') }
      ]
    }
  },
  computed: {
    ...mapState({
      engravedId: state => state.card.filter.engravedId,
      ascription: state => state.card.filter.combinedAscriptions,
      cardReplacementStatus: state => state.card.filter.cardReplacementStatus
    })
  },
  validations () {
    return {
      engravedId: {},
      ascription: {
        maxLength: maxLength(50)
      },
      cardReplacementStatus: {}
    }
  },
  methods: {
    ...mapMutations('card', {
      setFilterPair: SET_FILTER_PAIR
    }),
    ...mapActions('card', [
      'resetCurrentPageNumber'
    ]),
    setEngravedId: function (value) {
      this.setFilterPair(buildFilterPair(FILTER_ENGRAVED_ID, value))
    },
    setAscription: function (value) {
      this.setFilterPair(buildFilterPair(FILTER_COMBINED_ASCRIPTIONS, value))
    },
    setCardReplacementStatus: function (value) {
      this.setFilterPair(buildFilterPair(FILTER_CARD_REPLACEMENT_STATUS, value))
    },
    filter: function () {
      this.resetCurrentPageNumber()
      this.$emit('submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/CardFilterForm.vue